import { createActionCreators, createReducerFunction, ImmerReducer } from 'immer-reducer';
import IMergeTransactionState from '../../interfaces/states/IMergeTransactionState';

const initialState: IMergeTransactionState = {
  visible: false,
};

class MergeTransactionReducer extends ImmerReducer<IMergeTransactionState> {
  public showMergeTransactionDisplay(): void {
    this.draftState.visible = true;
  }

  public hideMergeTransactionDisplay(): void {
    this.draftState = initialState;
  }
}

export const MergeTransactionActions = createActionCreators(MergeTransactionReducer);
export const MergeTransactionReducerFunction = createReducerFunction(
  MergeTransactionReducer,
  initialState,
);
